// Types compartilhados pelos sub-componentes de Admin.
// Extraído de Admin.tsx durante refactor topológico.

export interface Usuario {
  username: string; email: string; nome: string; telefone?: string;
  status: string; enabled: boolean;
  criado_em: string; atualizado_em: string;
  groups: string[];
}

export interface Grupo { name: string; description: string | null; }

export const STATUS_LABEL: Record<string, string> = {
  FORCE_CHANGE_PASSWORD: 'Primeiro login',
  CONFIRMED: 'Ativo', ARCHIVED: 'Arquivado',
  COMPROMISED: 'Comprometido', UNKNOWN: 'Desconhecido',
  RESET_REQUIRED: 'Reset necessário', UNCONFIRMED: 'Não confirmado',
};

export type AdminTab = 'usuarios' | 'perfis' | 'permissoes' | 'd4sign' | 'empresa' | 'backlog' | 'aws-costs' | 'backup-nas';

// ─── PERMISSÕES ─────────────────────────────────────────────────────
export interface Permissao {
  operacao_id: string;
  modulo: 'comercial' | 'financeiro' | 'admin' | 'agentes';
  descricao: string;
  risco: 'CRITICO' | 'ALTO' | 'MEDIO' | 'BAIXO';
  grupos: string[];
  atualizado_em: string | null;
  atualizado_por: string | null;
}
export const GRUPOS_COLUNAS: Array<{ id: string; label: string; cor: string }> = [
  { id: 'admin',             label: 'admin',             cor: '#020D7F' },
  { id: 'financeiro_editor', label: 'financeiro_editor', cor: '#0a7f4a' },
  { id: 'financeiro_view',   label: 'financeiro_view',   cor: '#5FBA7D' },
  { id: 'financeiro',        label: 'financeiro (legado)', cor: '#888' },
  { id: 'comercial',         label: 'comercial',         cor: '#7C3AED' },
  { id: 'diretoria',         label: 'diretoria',         cor: '#B07500' },
];
export const RISCO_TAG_COLOR: Record<string, string> = {
  CRITICO: 'red', ALTO: 'gold', MEDIO: 'blue', BAIXO: 'default',
};
export const MODULO_LABEL: Record<string, string> = {
  comercial: '🏢 Comercial', financeiro: '💰 Financeiro',
  admin: '⚙️ Admin', agentes: '🤖 Agentes',
};

// ─── BACKLOG ─────────────────────────────────────────────────────
export interface BacklogItem {
  id: string; titulo: string; descricao: string | null;
  categoria: 'bug' | 'melhoria' | 'feature' | 'duvida' | 'tarefa';
  modulo: string | null;
  prioridade: 'baixa' | 'media' | 'alta' | 'urgente';
  status: 'aberto' | 'em_progresso' | 'feito' | 'descartado';
  origem: string; criado_em: string; criado_por: string | null;
  resolvido_em: string | null; resolvido_por: string | null; resolvido_commit: string | null;
}

export const CAT_INFO: Record<string, { label: string; tagColor: string; icon: string }> = {
  bug:      { label: 'Bug',      tagColor: 'red',     icon: '🐛' },
  melhoria: { label: 'Melhoria', tagColor: 'blue',    icon: '✨' },
  feature:  { label: 'Feature',  tagColor: 'purple',  icon: '🎁' },
  duvida:   { label: 'Dúvida',   tagColor: 'gold',    icon: '❓' },
  tarefa:   { label: 'Tarefa',   tagColor: 'green',   icon: '✓' },
};
export const PRIO_INFO: Record<string, { label: string; cor: string }> = {
  baixa:   { label: 'Baixa',   cor: '#888' },
  media:   { label: 'Média',   cor: '#0930D0' },
  alta:    { label: 'Alta',    cor: '#B07500' },
  urgente: { label: 'Urgente', cor: '#B91626' },
};
export const STATUS_INFO: Record<string, { label: string; tagColor: string }> = {
  aberto:       { label: 'Aberto',       tagColor: 'gold' },
  em_progresso: { label: 'Em progresso', tagColor: 'blue' },
  feito:        { label: 'Feito',        tagColor: 'green' },
  descartado:   { label: 'Descartado',   tagColor: 'default' },
};
export const MODULOS = ['comercial', 'financeiro', 'operacional', 'dwight', 'admin', 'geral'];

// ─── EMPRESA ─────────────────────────────────────────────────────
export interface EmpresaDados {
  id: string;
  razao_social?: string | null; nome_fantasia?: string | null;
  cnpj?: string | null; inscricao_estadual?: string | null; inscricao_municipal?: string | null;
  logradouro?: string | null; numero?: string | null; complemento?: string | null;
  bairro?: string | null; cidade?: string | null; uf?: string | null; cep?: string | null;
  telefone_principal?: string | null; telefone_secundario?: string | null;
  email_geral?: string | null; email_comercial?: string | null; email_financeiro?: string | null;
  website?: string | null;
  crea_numero?: string | null; crea_uf?: string | null; crea_validade?: string | null;
  outros_registros?: Array<{ tipo: string; numero: string; uf?: string; validade?: string }>;
  bancos?: Array<{ banco: string; agencia: string; conta: string; tipo?: string; pix?: string }>;
  representantes?: Array<{ nome: string; cpf: string; cargo: string; principal?: boolean }>;
  logo_s3_key?: string | null;
  logo_url?: string | null;
  atualizado_em?: string | null; atualizado_por?: string | null;
}
